import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const CancelIcon = (properties: iconType) => (
  <SvgIcon
    {...properties}
    viewBox="0 0 10 10"
    style={{ fill: 'none', width: '10px', height: '10', stroke: '#78869E' }}
  >
    <path d="M1 9L9 1" />
    <path d="M9 9L1 1" />
  </SvgIcon>
);

CancelIcon.defaultProperties = {
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  stroke: '#78869E',
  strokeWidth: '2',
};

export default CancelIcon;
